import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { BillsTab } from "@/components/payables/BillsTab";

export function _RejectDialog({ rejectingBill, setRejectingBill, rejectReason, setRejectReason, rejectBill }) {
  // Extracted to keep BillsTab body more compact.
  return (
    <Dialog open={!!rejectingBill}
             onOpenChange={(v) => { if (!v) { setRejectingBill(null); setRejectReason(""); } }}>
      <DialogContent className="max-w-md" data-testid="bill-reject-dialog">
        <DialogHeader>
          <DialogTitle>Reject bill</DialogTitle>
          <DialogDescription>
            Bill {rejectingBill?.number} · {rejectingBill?.vendor_name}
          </DialogDescription>
        </DialogHeader>
        <div>
          <Label>Reason (optional)</Label>
          <Textarea rows={3} value={rejectReason}
                     onChange={(e) => setRejectReason(e.target.value)}
                     placeholder="Missing PO, wrong amount, needs vendor W-9…"
                     data-testid="bill-reject-reason" />
        </div>
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={() => { setRejectingBill(null); setRejectReason(""); }}>
            Cancel
          </Button>
          <Button onClick={rejectBill}
                   data-testid="bill-reject-confirm"
                   className="bg-[#B4283A] hover:bg-[#93202E] text-white">
            Reject
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
